/* Magento Internal Orders Store */

import {updateInternalMagentoOrder} from '@/api'

const state = {}

const actions = {
    updateInternalMagentoOrder (context, params) {
        return updateInternalMagentoOrder(params)
    }
}

const mutations = {}

const getters = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}